<template>
    <div>
        <NavbarTwo />
        <div class="page-safestcompass compass-container">
            <div class="hero-section">
                <div class="container">
                    <h1>SAFEST Patient Safety COMPASS</h1>
                    <p>SAFEST Patient Safety COMPASS is a conceptual guide that includes 101 Perioperative Patient Safety Recommendations to enhance safety and quality of care in hospitals and other healthcare settings.</p>
                    <div class="hero-section__buttons">
                        <a href="/compass" class="default-btn style-two">Go to the compass</a>
                        <a href="https://compass.esaic.org/perioperative-patient-safety-recommendations/" class="btn-explore" download>Download the PPSR in multiple languages</a>
                    </div>
                </div>
            </div>

            <div class="development-section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
							<div class="development-section__content">
								<h2>How was it developed?</h2>
								<p>A multimethod analysis was conducted to create the Compass, which included a synthesis of evidence-based Perioperative Patient Safety Recommendations through a systematic review of clinical practice guidelines. A consensus process followed, involving multidisciplinary advisory groups, a two-round modified Delphi survey, and a two-day consensus conference, ensuring a balanced and inclusive approach.</p>
							</div>
                        </div>
                        <div class="col-lg-6">
                            <img src="../img/compass.png" alt="Compass wheel diagram" class="compass-wheel">
                        </div>
                    </div>
                </div>
            </div>

            <div class="result-section">
                <div class="container text-center">
                    <h2>The result</h2>
                    <p>101 Perioperative Patient Safety Recommendations grouped into 12 key standards</p>

                    <div class="categories-grid">
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-safety.svg" alt="Safety & Quality Icon">
                            </div>
                            <h3>Safety & Quality Management</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-human.svg" alt="Human Resources Icon">
                            </div>
                            <h3>Human Resources</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-equipment.svg" alt="Equipment Icon">
                            </div>
                            <h3>Equipment</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-communication.svg" alt="Communication Icon">
                            </div>
                            <h3>Communication</h3>
                        </div>

                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-patient.svg" alt="Patient Information Icon">
                            </div>
                            <h3>Patient Information</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-preoperative.svg" alt="Preoperative Evaluation Icon">
                            </div>
                            <h3>Preoperative Evaluation</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-continuity.svg" alt="Continuity of Care Icon">
                            </div>
                            <h3>Continuity of Care</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-medication.svg" alt="Medication Safety Icon">
                            </div>
                            <h3>Medication Safety</h3>
                        </div>

                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-blood.svg" alt="Blood Management Icon">
                            </div>
                            <h3>Blood Management</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-infection.svg" alt="Infection Prevention Icon">
                            </div>
                            <h3>Infection Prevention</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-intraoperative.svg" alt="Intraoperative Complications Icon">
                            </div>
                            <h3>Intraoperative Complications Prevention</h3>
                        </div>
                        <div class="category-card">
                            <div class="icon-container blue">
                                <img src="../img/logo-common.svg" alt="Common Complications Icon">
                            </div>
                            <h3>Common Complications Prevention</h3>
                        </div>
                    </div>

                    <p class="disclaimer">The Compass serves as a reference for safety policies, healthcare training, and standard evaluation, fostering a culture of safety and quality in medical care, For doctors, patients, nurses, and all healthcare team members.</p>
                </div>
            </div>

            <div class="idea-section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
							<div class="idea-section__content">
                            <h2>Where Did the Idea Come From?</h2>
                            <p>The Health and Safety Compass originates from the European SAFEST project, which aims to enhance patient safety by harmonizing perioperative care across European countries.</p>
                            <p>To achieve this goal, the project employs a mixed-methods research approach, actively involving both patients and healthcare professionals at every stage.</p>
                            <p>Through this process, SAFEST identifies a set of evidence-based perioperative safety practices, known as the "SAFEST Standardized Practices." These practices are widely supported at the European level and serve as the foundation for the Compass.</p>
							<p>A Quality Improvement Learning Collaborative facilitates the adoption of these practices by:</p>

                            <ul class="project-goals">
                                <li>Identifying key factors that influence implementatio</li>
                                <li>Developing actionable recommendations</li>
                                <li>Sharing lessons learned</li>
                            </ul>

                            <p>The Compass focuses on ensuring patient safety throughout the entire perioperative journey, from pre-hospital care to postoperative recovery at home or in outpatient facilities.</p>

                            <div class="logos">
                                <img src="../img/safest-logo.png" alt="SAFEST Logo" height="40">
                                <img src="../img/funded-by.png" alt="EU Logo" height="40">
                            </div>
							</div>
                        </div>
                        <div class="col-md-6">
                            <img src="../img/working-on-computer.png" alt="Working on computer" class="laptop-image">
                        </div>
                    </div>
                </div>
            </div>

            <div class="next-section">
                <div class="container text-center">
                    <h2>What's Next?</h2>
                    <p>Here, we present the Health and Safety Compass, a comprehensive guide where you can explore and delve deeper into each of the 101 Perioperative Patient Safety Recommendations to better understand and enhance perioperative safety. You will find the full content of the 101 recommendations, along with an example for each one. Additionally, you can download all this information for further reference.</p>
                </div>
            </div>

            <div class="welcome-card">
                <div class="container">
                    <div class="card-content text-center">
                        <img src="../assets/safest/logo-SAFEST_hi-res.jpg" alt="SAFEST Logo" height="60">
                        <h2>Welcome to the Safest<br>Patient Compass</h2>
                        <p>A mapping tool conceived as an all-in-one solution to provide a whole overview of the complex SAFEST Perioperative Patient Safety Recommended Practices (PPSR). It is designed to allow an easy understanding of its context and background at a quick and simple glance, and directs to an agile analysis and navigation of the 101 PPSR.</p>
                        <a href="/compass" class="btn-get-started">Get Started</a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import NavbarTwo from '../components/Layout/NavbarTwoSafest'

export default {
    components: {
        NavbarTwo
    },
    mounted() {
        this.$metas({
            title: 'Safest | Compass',
            description: 'Learn about the Health and Safety Compass - a comprehensive guide for ensuring patient safety throughout the surgical pathway.',
        })
    }
}
</script>

<style>
.page-safestcompass .compass-container {
    font-family: 'Helvetica', 'Arial', sans-serif;
    color: #333;
}

.page-safestcompass .hero-section {
    padding: 80px 0;
    text-align: center;
}

.page-safestcompass .hero-section h1 {
    color: #155B8D;
    font-size: 3.5rem;
    margin-bottom: 20px;
}

.page-safestcompass .hero-section p {
    max-width: 800px;
    margin: 0 auto;
}

.page-safestcompass .default-btn.style-two {
    border: 2px solid transparent;
    font-weight: 600;
}

.page-safestcompass .hero-section__buttons {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    flex-wrap: wrap;

    a {
        margin: 0;
    }
}

.btn-primary {
    background-color: #155B8D;
    color: #fff;
    padding: 12px 30px;
    border-radius: 5px;
    font-weight: bold;
}

.page-safestcompass .btn-explore {
    background-color: #fff;
    border: 1px solid #155B8D;
    color: #155B8D;
    padding: 12px 30px;
    border-radius: 5px;
    font-weight: bold;
    margin-top: 20px;
    cursor: pointer;
    display: inline-block;
    transition: background-color 0.3s;
}

.page-safestcompass .h1, .page-safestcompass .h2, .page-safestcompass .h3, .page-safestcompass .h4, .page-safestcompass .h5, .page-safestcompass .h6, .page-safestcompass h1, .page-safestcompass h2, .page-safestcompass h3, .page-safestcompass h4, .page-safestcompass h5, .page-safestcompass h6 {
    font-weight: 700 !important;
}

.page-safestcompass .btn-explore:hover {
    background-color: #155B8D;
    color: #fff;
}

.page-safestcompass p, .page-safestcompass ul, .page-safestcompass ol {
    line-height: 1.5 !important;
    font-size: 16px !important;
    color: #155B8D !important;
}

.page-safestcompass .development-section {
    padding: 60px 0;
    background-color: #ffffff;
}

.page-safestcompass .development-section .col-lg-6:nth-child(2) {
    padding-right: 0;
    padding-left: 0;
}

.page-safestcompass .development-section .container {
    background-color: #F8F9F8;
}

.page-safestcompass .development-section__content {
    padding: 80px 80px;

    @media (max-width: 768px) {
        padding:30px;
    }
}

.page-safestcompass .development-section h2 {
    color: #155B8D;
    margin-bottom: 25px;
}

.page-safestcompass .development-section .col-md-6:nth-child(2) {
    padding-right: 0;
}

.page-safestcompass .compass-wheel {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
}

.page-safestcompass .result-section {
    padding: 80px 0;
}

.page-safestcompass .result-section h2 {
    color: #155B8D;
    margin-bottom: 20px;
}

.page-safestcompass .categories-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin: 40px 0;
}

.page-safestcompass .category-card {
    padding: 60px 40px;
    border-radius: 8px;
    text-align: center;
    background: #F8F9F8;
}

.page-safestcompass .icon-container {
    width: 70px;
    height: 70px;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}



.page-safestcompass .icon-container img {
    width: auto;
    height: 80px;

    @media (max-width: 768px) {
        height: 60px;
    }
}

.page-safestcompass .category-card h3 {
    font-size: 24px;
    color: #155B8D;
    margin-top: 20px;

    @media (max-width: 768px) {
        font-size: 18px;
    }
}

.page-safestcompass .disclaimer {
    font-size: 0.9rem;
    color: #155B8D;
    margin-top: 60px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.page-safestcompass .idea-section {
    background-color: #F8F9F8;
}

.page-safestcompass .idea-section__content {
    padding: 80px 40px;
}

.page-safestcompass .idea-section h2 {
    color: #155B8D;
    margin-bottom: 25px;
}

.page-safestcompass .project-goals {
    list-style: none;
    padding-left: 0;
    margin: 20px 0;
}

.page-safestcompass .project-goals li {
    position: relative;
    padding-left: 25px;
}

.page-safestcompass .project-goals li:before {
    content: "✓";
    color: #155B8D;
    position: absolute;
    left: 0;
}

.page-safestcompass .logos {
    margin-top: 30px;
    display: flex;
    gap: 20px;
    align-items: center;
    flex-wrap: wrap;
}

.page-safestcompass .laptop-image {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
}

.page-safestcompass .next-section {
    padding: 80px 0;
}

.page-safestcompass .next-section h2 {
    color: #155B8D;
    margin-bottom: 20px;
}

.page-safestcompass .next-section p {
    max-width: 800px;
    margin: 0 auto;
}

.page-safestcompass .welcome-card {
    padding: 50px 0 100px;
    background-color: #ffffff;
}

.page-safestcompass .card-content {
    max-width: 700px;
    margin: 0 auto;
    background-color: #fff;
    padding: 40px;
    border-radius: 8px;


filter: drop-shadow(0px 143px 57px rgba(107, 107, 107, 0.01)) drop-shadow(0px 81px 48px rgba(107, 107, 107, 0.05)) drop-shadow(0px 36px 36px rgba(107, 107, 107, 0.09)) drop-shadow(0px 9px 20px rgba(107, 107, 107, 0.1));

}

.page-safestcompass .card-content h2 {
    color: #155B8D;
    margin: 20px 0;
}

.page-safestcompass .btn-get-started {
    background-color: #FF5757;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 5px;
    font-weight: bold;
    margin-top: 20px;
    cursor: pointer;
    transition: background-color 0.3s;
    display: inline-block;
}

.page-safestcompass .btn-get-started:hover {
    background-color: #e54545;
    color: #fff;
}

.page-safestcompass .footer-logos {
    padding: 30px 0;
    background-color: #f8f8f8;
}

.page-safestcompass .footer-logos img {
    margin: 0 15px;
}

@media (max-width: 992px) {
    .page-safestcompass .categories-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .page-safestcompass .categories-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .page-safestcompass .category-card {
        padding: 20px;
    }

    .page-safestcompass .idea-section__content {
        padding: 50px 30px;
    }

    .page-safestcompass .hero-section h1 {
        font-size: 2rem;
    }
}
</style>